export const theme = {
  colors: {
    primary: 'var(--colors-primary)',
    primaryHover: 'var(--colors-primary-hover)',
    secondary: 'var(--colors-secondary)',
    placeholder: 'var(--colors-placeholder)',
    background: 'var(--colors-background)',
    surface: 'var(--colors-surface)',
    border: 'var(--colors-border)',
    text: 'var(--colors-text)',
    textSecondary: 'var(--colors-text-secondary)',
    white: 'var(--colors-white)',
    grayTableBackground: 'var(--colors-gray-table-background)',
    darkGrayBackground: 'var(--colors-dark-gray-background)',
    selectedBackground: '#F2F2F2',
    tableHeaderColor: 'var(--colors-table-header-color)',
    tableSortHeaderColor: 'var(--colors-table-sort-header-color)'
  }
} as const

export const cssVariables = `
  :root {
    --colors-primary: #3374C8;
    --colors-primary-hover: #E8F0F7;
    --colors-secondary: #202A66;
    --colors-placeholder: #666;
    --colors-background: #f5f5f5;
    --colors-dark-gray-background: #c9c9c9;
    --colors-surface: #ffffff;
    --colors-border: #d1d8e0;
    --colors-text: #374151;
    --colors-text-secondary: #66707d;
    --colors-white: #ffffff;
    --colors-gray-table-background: #E4E8E9;
    --colors-table-header-color: #595959;
    --colors-table-sort-header-color: #0055B7;
  }
`
